'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  XS: 'Less than $100,000',
  S: '$100,000 - $1,000,000',
  M: '$1,000,000 - $10,000,000',
  L: '$10,000,000 - $50,000,000',
  XL: 'More than $50,000,000'
});